import React from 'react';
// import { NavLink } from 'react-router-dom';
import Banner from '../components/Banner';
// import Navigation from '../components/navigation';
import Navigation from '../components/navigation2';
import Footer from '../components/Footer';
// import flechedroitegrise from '../assets/flechedroitegrise.jpg';
// import ciblegrise from '../assets/ciblegrise.jpg';
import '../styles/pages/arroweb.css';


const Arroweb = () => {
    return (
        <div>
            <Banner />
            <div className='blocPage'>
                <div className='blocArrow1'>
                    <Navigation />
                    <h1 className='arroweb_titre'>Pour un site fiable et durable</h1>
                    <h2>ArroWeb Développement vous accompagne dans la création d’un site internet professionnel, adapté à vos besoins et à votre image.</h2>
                    <h2>Nous mettons l’accent sur la fiabilité, la sécurité et la pérennité de votre projet web, pour vous garantir une présence en ligne efficace et durable.</h2>
                    <h2 className='arroweb_titre'>Choisissez ArroWeb Développement</h2>
                </div>
                {/* <div className='animationfleche'>
                    <div>
                        <NavLink to="/realisations">
                            <p className="ciblegrise"><img src={ciblegrise} alt="cible" className='cibleflechedroite' /></p>
                        </NavLink>
                    </div>
                    <div className='loader'>
                        <img src={flechedroitegrise} alt="fleche" className='flechedroite' />
                    </div>
                    <p className='assurance'>ArroWeb Dévéloppement, c'est l'assurance d atteintre votre objectif</p>
                </div> */}
                <div className='blocArrow2'>
                    <p className='arroweb_texte'>ArroWeb Développement est né de la passion de l'informatique et du développement web de son créateur Fabrice FLECHE</p>
                    <p className='arroweb_texte'>Titulaire d'une formation de niveau 5 en développement web</p>
                    <p className='arroweb_texte'>Fort d'une expérience de plusieurs années dans le domaine</p>
                    <p className='arroweb_texte'>ArroWeb Développement s'engage à vous fournir un service de qualité, adapté à vos besoins spécifiques.</p>

                </div>
                <div className='blocArrow3'>
                    <p className='arroweb_texte'>Que vous cherchez à avoir de la visibilité sur internet ou que vous avez besoin d'un site de e-commerce pour vendre vos produits</p>
                    <p className='arroweb_texte'>ArroWeb Developpement est à votre écoute de vos besoins pour la réalisation de votre site web</p>
                    <p className='arroweb_texte'>Votre site web sera une solution sur-mesure</p>
                    <p className='arroweb_texte'>Nous établirons un cahier des charges, pour définir le design et les fonctions souhaitées</p>

                </div>
            </div>
            <Footer />
        </div>

    );
};

export default Arroweb;